export default function InputField({ label, type = "text", name,placeholder, value, onChange, error }) {
  return (
      <div className="flex flex-col text-right gap-1 w-full">
          <label className="text-sm pr-1">{label}</label>
              <input
                  type={type}
                  name={name}
                  value={value}
                  placeholder={placeholder}
                  onChange={onChange}
                  className={`border px-3 py-2 rounded w-full text-right ${
                      error ? "border-red-500" : "border-gray-300"
                  }`}
              />
              {error && <span className="text-xs text-red-600">{error}</span>}
          </div>
          );
          }

